module.exports = __webpack_public_path__ + "img/united-states.8f09571c.svg";